// Only generated tender notes have a known field structure; ordinary notes stay verbatim.
export function parseTenderRemark(value, source) {
  const text = String(value || '')
  const legacy = text.startsWith('污水处理招投标信息：')
  if (!legacy && !(source === '招投标网络采集' && text.startsWith('项目：'))) return []
  const labels = '项目|AI摘要|联系记录|联系人身份|需求方向|确认需求|项目阶段|下一步|公告链接'
  const normalized = legacy ? text.replace(/^污水处理招投标信息：/, '项目：').replace(new RegExp('；(?=(?:' + labels + ')：)', 'g'), '\n') : text
  return normalized.split(new RegExp('\n(?=(?:' + labels + ')：)')).map(line => {
    const colon = line.indexOf('：')
    const label = line.slice(0, colon)
    const content = line.slice(colon + 1).trim()
    return { label: label === 'AI摘要' ? '项目摘要' : label === '联系记录' ? '联系进展' : label, value: content,
      url: label === '公告链接' && /^https?:\/\/[^\s<>"']+$/i.test(content) ? content : '' }
  }).filter(item => item.value && item.value !== 'null')
}
